import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {stringify} from '@angular/compiler/src/util';

@Component({
  selector: 'app-truck-input[formControlName]',
  templateUrl: './truck-input.component.html',
  styleUrls: ['./truck-input.component.scss']
})
export class TruckInputComponent {

  @Input() id ?: string;
  @Input() inputType = 'text';
  @Input() labelText ?: string;
  @Input() formControlName = '';
  @Input() optional = false;

}
